import { selectOutOfScope } from 'legacy/lut/features/partner360/configuration'
import { ComponentClass, FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'

type Options = {
  overlayPlaceholder?: ReactNode
}

export function withInScopeCheck<P extends object>(
  Component: FC<P> | ComponentClass<P>,
  { overlayPlaceholder }: Options = {}
): FC<P> {
  return (props) => {
    const outOfScope = useSelector(selectOutOfScope)
    if (outOfScope) {
      if (overlayPlaceholder) {
        return <>{overlayPlaceholder}</>
      }

      return null
    }

    return <Component {...props} />
  }
}
